// extracted by mini-css-extract-plugin
export default {"linkItem":"linkItem___jI81W"};